// 공지사항 헤더 컴포넌트
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '@/contexts/AppContext';
import type { AnnouncementTranslations } from './types';

interface AnnouncementHeaderProps {
  onBack: () => void;
  translations: AnnouncementTranslations;
}

export function AnnouncementHeader({ onBack, translations }: AnnouncementHeaderProps) {
  const { language } = useLanguage();
  return (
    <div className="sticky top-0 z-50 bg-primary">
      <div className="flex items-center justify-between h-[50px] px-5">
        <button onClick={onBack} className="flex items-center justify-center w-8 h-8">
          <ArrowLeft className="w-5 h-5 text-primary-foreground" />
        </button>
        <h1
          className={`text-primary-foreground font-bold text-base tracking-[-0.32px] text-center ${language !== 'ko' ? 'uppercase' : ''}`}
        >
          {translations.title}
        </h1>
        <div className="w-8" />
      </div>
    </div>
  );
}
